(function () {
  var rentalMiniBagHiddenVariantIds = [
    47525588238523,
    47541269823675,
    47943771488443,
    47943772995771,
    47943792853179,
    47943796097211,
    47939116859579,
    47939117285563,
    48226709143739,
    48028946235579,
    47943498989755,
    47943499776187,
    48199696548027,
    48199699824827,
    47526006063291,
    47994120241339,
    47994120339643,
    48111443509435,
    48111444099259,
    47939100672187,
    48000206274747,
    48000206700731,
    48000207061179,
    48000207388859,
    48000136282299,
    48000145031355,
    47939105030331,
    47939105980603,
    47939106078907,
    48205548290235,
    48221763272891,
    48220729606331,
    47939187343547,
    47939187605691,
    47939187671227,
    47939188719803,
    47939189276859,
    47939190161595,
    47939191931067,
    47939192258747,
    48000175931579,
    47939193307323,
    48220744155323,
    48012018843835,
    47940834984123,
    48011984797883,
    48221678796987,
    47940837474491,
    48221653827771,
    47940838621371,
    47940843143355,
    48199708836027,
    48199708967099,
    48199708999867,
    48221681189051,
    48199709163707,
    48221655466171,
    48199710081211,
    48199710212283
  ].map(function (id) {
    return String(id);
  });

  var cachedCart = null;
  var refreshPromise = null;
  var renderScheduled = false;
  var observer = null;
  var RENDER_MARKER = 'data-rental-mini-bag-edit-rendered';
  var RENTAL_EDIT_CACHE_PREFIX = 'playforceRentalEditCacheV1:';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalisePropertyValue(value) {
    if (value === null || typeof value === 'undefined') return '';
    return String(value).trim();
  }

  function isRentalMiniBagHiddenItem(item) {
    if (!item) return false;

    var itemId = String(item.id || item.variant_id || '');
    if (rentalMiniBagHiddenVariantIds.indexOf(itemId) !== -1) return true;

    var properties = item.properties || {};
    if (normalisePropertyValue(properties['Charge type'])) return true;
    if (normalisePropertyValue(properties['_rental_hidden_in_bag']).toLowerCase() === 'true') return true;

    return false;
  }

  function getRentalGroupId(item) {
    if (!item || !item.properties) return '';
    return normalisePropertyValue(item.properties['Rental group ID']);
  }

  function getRentalMiniBagProcessorLabel(item) {
    if (!item) return '';

    var namedOptions = Array.isArray(item.options_with_values)
      ? item.options_with_values
      : [];

    for (var i = 0; i < namedOptions.length; i += 1) {
      var optionName = normalisePropertyValue(namedOptions[i] && namedOptions[i].name).toLowerCase();
      if (optionName === 'processor') {
        var processorValue = normalisePropertyValue(namedOptions[i] && namedOptions[i].value);
        if (processorValue) return processorValue;
      }
    }

    var variantOptions = Array.isArray(item.variant_options)
      ? item.variant_options.map(normalisePropertyValue).filter(Boolean)
      : [];

    var rentalPeriodPattern = /^(?:cal\b.*|\d+\s*(?:day|days|week|weeks|month|months)|\d+\s*(?:d|w|m))$/i;
    var nonPeriodOptions = variantOptions.filter(function (value) {
      return value.toLowerCase() !== 'default title' && !rentalPeriodPattern.test(value);
    });

    if (nonPeriodOptions.length) {
      return nonPeriodOptions[0];
    }

    var variantTitle = normalisePropertyValue(item.variant_title);
    if (!variantTitle || variantTitle.toLowerCase() === 'default title') return '';

    var titleParts = variantTitle.split(' / ').map(normalisePropertyValue).filter(Boolean);
    var processorParts = titleParts.filter(function (value) {
      return !rentalPeriodPattern.test(value);
    });

    return processorParts.join(' / ') || variantTitle;
  }

  function getRentalMiniBagItemUrl(item) {
    if (!item) return '/cart';

    var itemUrl = normalisePropertyValue(item.url) || '/cart';
    var rentalGroupId = getRentalGroupId(item);
    if (!rentalGroupId) return itemUrl;

    try {
      var url = new URL(itemUrl, window.location.origin);
      url.searchParams.delete('variant');
      url.searchParams.set('edit_rental', rentalGroupId);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      var productUrl = itemUrl.split('?')[0] || itemUrl;
      return productUrl + '?edit_rental=' + encodeURIComponent(rentalGroupId);
    }
  }

  function rentalMiniBagItemIsLinkedCharge(item) {
    var properties = item && item.properties ? item.properties : {};
    return !!(
      normalisePropertyValue(properties['Charge type']) ||
      normalisePropertyValue(properties['Linked rental product']) ||
      normalisePropertyValue(properties['Linked rental variant'])
    );
  }

  function compactRentalMiniBagEditItem(item) {
    if (!item) return null;

    return {
      id: Number(item.id || item.variant_id || 0),
      variant_id: Number(item.variant_id || item.id || 0),
      product_id: Number(item.product_id || 0),
      quantity: Math.max(1, Number(item.quantity) || 1),
      variant_title: normalisePropertyValue(item.variant_title),
      properties: item.properties && typeof item.properties === 'object'
        ? Object.assign({}, item.properties)
        : {}
    };
  }

  function cacheRentalMiniBagEditConfiguration(item) {
    var groupId = getRentalGroupId(item);
    if (!groupId || !cachedCart || !Array.isArray(cachedCart.items)) return;

    var groupItems = cachedCart.items.filter(function (cartItem) {
      return getRentalGroupId(cartItem) === groupId;
    });

    var mainItem = groupItems.find(function (cartItem) {
      return !rentalMiniBagItemIsLinkedCharge(cartItem);
    }) || item;

    try {
      window.sessionStorage.setItem(
        RENTAL_EDIT_CACHE_PREFIX + groupId,
        JSON.stringify({
          version: 1,
          groupId: groupId,
          productId: Number(mainItem.product_id || 0),
          savedAt: Date.now(),
          mainItem: compactRentalMiniBagEditItem(mainItem),
          groupItems: groupItems.map(compactRentalMiniBagEditItem).filter(Boolean)
        })
      );
    } catch (error) {}
  }

  function ensureRentalMiniBagEditStyles() {
    if (document.getElementById('RentalMiniBagEditStyles')) return;

    var style = document.createElement('style');
    style.id = 'RentalMiniBagEditStyles';
    style.textContent =
      '.rental-mini-bag-edit-label{' +
        'display:block;' +
        'margin-top:4px;' +
        'color:#5b6472;' +
        'font-size:12px;' +
        'font-weight:500;' +
        'line-height:1.3;' +
      '}' +
      '.cart_popup_box .cart_row>a:hover .rental-mini-bag-edit-label{' +
        'color:#0055cc;' +
      '}';
    document.head.appendChild(style);
  }

  function getVisibleItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.filter(function (item) {
      return !isRentalMiniBagHiddenItem(item);
    });
  }

  function getExpectedSignature(visibleItems) {
    return visibleItems.slice(0, 3).map(function (item) {
      return [
        String(item.id || item.variant_id || ''),
        String(item.quantity || 1),
        getRentalGroupId(item),
        getRentalMiniBagProcessorLabel(item),
        getRentalMiniBagItemUrl(item)
      ].join('|');
    }).join('||');
  }

  function popupAlreadyMatches(cartItemWrap, visibleItems) {
    if (!cartItemWrap) return false;

    var expectedSignature = getExpectedSignature(visibleItems);
    var currentSignature = cartItemWrap.getAttribute(RENDER_MARKER) || '';
    if (currentSignature !== expectedSignature) return false;

    var expectedRows = Math.min(visibleItems.length, 3);
    var actualRows = cartItemWrap.querySelectorAll('.cart_row[data-rental-mini-bag-main="true"]').length;
    if (actualRows !== expectedRows) return false;

    var links = cartItemWrap.querySelectorAll('.cart_row[data-rental-mini-bag-main="true"] > a');
    for (var i = 0; i < links.length; i += 1) {
      var expectedUrl = getRentalMiniBagItemUrl(visibleItems[i]);
      if ((links[i].getAttribute('href') || '') !== expectedUrl) return false;
    }

    return true;
  }

  function renderRentalMiniBag(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cachedCart = cart;
    var visibleItems = getVisibleItems(cart);
    var expectedSignature = getExpectedSignature(visibleItems);

    document.querySelectorAll('.cart_popup_box').forEach(function (popupBox) {
      var cartItemWrap = popupBox.querySelector('.cart_item_block .cart_item');
      if (!cartItemWrap) return;
      if (popupAlreadyMatches(cartItemWrap, visibleItems)) return;

      if (!visibleItems.length) {
        var emptyText = cart.item_count > 0
          ? 'Rental charges are linked to the main rental.'
          : 'is currently empty.';

        cartItemWrap.innerHTML = '<div class="item_empty">' + escapeHtml(emptyText) + '</div>';
        cartItemWrap.setAttribute(RENDER_MARKER, expectedSignature);
        return;
      }

      var visibleLimit = 3;
      var visiblePreviewItems = visibleItems.slice(0, visibleLimit);
      var html = '';

      visiblePreviewItems.forEach(function (item, index) {
        var isLastVisibleItem = index === visiblePreviewItems.length - 1 && visibleItems.length <= visibleLimit;
        var rentalGroupId = getRentalGroupId(item);
        var itemUrl = getRentalMiniBagItemUrl(item);
        var quantityText = item.quantity && Number(item.quantity) !== 1
          ? '<br>x' + escapeHtml(item.quantity)
          : '';
        var processorLabel = rentalGroupId
          ? getRentalMiniBagProcessorLabel(item)
          : '';
        var editLabel = processorLabel
          ? '<span class="rental-mini-bag-edit-label">' + escapeHtml(processorLabel) + '</span>'
          : '';
        var imageHtml = item.image
          ? '<img width="100%" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title || '') + '">'
          : '<span class="rental-mini-bag-image-placeholder" aria-hidden="true"></span>';

        html +=
          '<figure class="cart_row item defualt_item ' + (isLastVisibleItem ? 'border-none' : '') + '"' +
            ' data-id="' + escapeHtml(item.id || item.variant_id || '') + '"' +
            ' data-line="' + escapeHtml(index + 1) + '"' +
            ' data-rental-mini-bag-main="true"' +
            ' data-rental-edit-group="' + escapeHtml(rentalGroupId) + '">' +
            '<a href="' + escapeHtml(itemUrl) + '" data-rental-mini-bag-edit-url="' + escapeHtml(itemUrl) + '">' +
              imageHtml +
              '<figcaption>' + escapeHtml(item.product_title || item.title || '') + quantityText + editLabel + '</figcaption>' +
            '</a>' +
          '</figure>';
      });

      if (visibleItems.length > visibleLimit) {
        var hiddenVisibleQuantity = visibleItems.slice(visibleLimit).reduce(function (total, item) {
          return total + (Number(item.quantity) || 1);
        }, 0);

        html += '<p class="other_item_hidden">' + hiddenVisibleQuantity + ' other item' + (hiddenVisibleQuantity > 1 ? 's' : '') + ' in bag</p>';
      }

      cartItemWrap.innerHTML = html;
      cartItemWrap.setAttribute(RENDER_MARKER, expectedSignature);
    });
  }

  function scheduleRenderFromCache() {
    if (renderScheduled || !cachedCart) return;
    renderScheduled = true;

    window.requestAnimationFrame(function () {
      renderScheduled = false;
      renderRentalMiniBag(cachedCart);
    });
  }

  function refreshRentalMiniBag(force) {
    if (refreshPromise && !force) return refreshPromise;

    refreshPromise = fetch('/cart.js?rental_mini_bag=' + Date.now(), {
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then(function (cart) {
        renderRentalMiniBag(cart);
        return cart;
      })
      .catch(function (error) {
        console.warn('Rental mini bag refresh failed:', error);
        return null;
      })
      .finally(function () {
        refreshPromise = null;
      });

    return refreshPromise;
  }

  function bindRentalMiniBagOpenTriggers() {
    var selectors = [
      '.cart_popup_button',
      '.cart_popup',
      '.site-header__cart',
      '[href="/cart"]'
    ];

    document.addEventListener('pointerdown', function (event) {
      var target = event.target && event.target.closest ? event.target.closest(selectors.join(',')) : null;
      if (!target) return;
      refreshRentalMiniBag(true);
      window.setTimeout(function () {
        refreshRentalMiniBag(true);
      }, 180);
      window.setTimeout(scheduleRenderFromCache, 420);
    }, true);

    document.addEventListener('mouseenter', function (event) {
      var target = event.target && event.target.closest ? event.target.closest(selectors.join(',')) : null;
      if (!target) return;
      refreshRentalMiniBag(false);
      window.setTimeout(scheduleRenderFromCache, 200);
    }, true);
  }

  function bindRentalMiniBagEditNavigation() {
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest
        ? event.target.closest('[data-rental-mini-bag-edit-url]')
        : null;
      if (!link) return;

      var editUrl = link.getAttribute('data-rental-mini-bag-edit-url') || link.getAttribute('href') || '';
      if (!editUrl) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var row = link.closest('[data-rental-mini-bag-main="true"]');
      var rentalGroupId = row ? String(row.getAttribute('data-rental-edit-group') || '').trim() : '';
      if (rentalGroupId && cachedCart && Array.isArray(cachedCart.items)) {
        var rentalItem = cachedCart.items.find(function (item) {
          return getRentalGroupId(item) === rentalGroupId && !rentalMiniBagItemIsLinkedCharge(item);
        });
        if (rentalItem) {
          cacheRentalMiniBagEditConfiguration(rentalItem);
        }
      }

      window.location.href = editUrl;
    }, true);
  }

  function observeRentalMiniBagChanges() {
    if (!window.MutationObserver || !document.body || observer) return;

    observer = new MutationObserver(function (mutations) {
      var shouldReapply = mutations.some(function (mutation) {
        if (mutation.type !== 'childList') return false;

        var target = mutation.target;
        if (!target || target.nodeType !== 1) return false;

        return !!(
          target.closest && target.closest('.cart_popup_box') ||
          target.querySelector && target.querySelector('.cart_popup_box')
        );
      });

      if (shouldReapply) {
        window.setTimeout(scheduleRenderFromCache, 0);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initRentalMiniBag() {
    ensureRentalMiniBagEditStyles();
    bindRentalMiniBagOpenTriggers();
    bindRentalMiniBagEditNavigation();
    observeRentalMiniBagChanges();
    refreshRentalMiniBag(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRentalMiniBag, { once: true });
  } else {
    initRentalMiniBag();
  }
})();
